/* unplugin-vue-components disabled */import { render } from "./dropdown-checkgroup.vue?vue&type=template&id=44875c3f"
import script from "./dropdown-checkgroup.vue?vue&type=script&lang=js"
export * from "./dropdown-checkgroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/filters/dropdown-checkgroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44875c3f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44875c3f', __exports__)) {
    api.reload('44875c3f', __exports__)
  }
  
  module.hot.accept("./dropdown-checkgroup.vue?vue&type=template&id=44875c3f", () => {
    api.rerender('44875c3f', render)
  })

}


export default __exports__